import { render, staticRenderFns } from "./floatMenu.vue?vue&type=template&id=2ea85932&scoped=true"
import script from "./floatMenu.vue?vue&type=script&lang=js"
export * from "./floatMenu.vue?vue&type=script&lang=js"
import style0 from "./floatMenu.vue?vue&type=style&index=0&id=2ea85932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea85932",
  null
  
)

export default component.exports